import nextTimesTpl from './next-times.tpl.html';
import timeSelectionTpl from './time-selection.tpl.html';
import nextTimesPersonTpl from './next-times-person.tpl.html';
import nextTimesLocationTpl from './next-times-location.tpl.html';
import nextTimesServiceTpl from './next-times-service.tpl.html';
import locationInfoTpl from './next-times-location-info.tpl.html';
import timesContainerTpl from './next-times-times-container.tpl.html';
import nonReservableTpl from './non-reservable-notice.tpl.html';
import spinnerTpl from './next-times-spinner.tpl.html';
import offlineTpl from './offline-service.tpl.html';
import noTimesTpl from './no-times.tpl.html';

import infoModalMod from '../common/components/infomodal/infomodal.component';

import './next-times.component.scss';

import angularSpinner from '../../common/wrappers/angular-spinner';
import cityResource from '../common/resources/city.resource';
import locationResource from '../common/resources/location.resource';
import serviceResource from '../common/resources/service.resource';
import nextTimesResource from '../common/resources/next-times.resource';
import personResource from '../common/resources/person.resource';
import geolocationService from '../common/location/geolocation.service';
import urlServiceMod from '../common/url.service';
import navButtonComponentMod from '../../common/material-components/buttons/nav-button.component';
import normalButtonComponentMod from '../../common/material-components/buttons/normal-button.component';
import commonUrlFiltersMod from '../common/common.urls';
import selectTimeButtonMod from '../reservation/datetime/select-time-button.component';
import LocationStorage from '../common/location/location-storage';
import flashMessageMod from '../../common/flashmessageservice/flashmessageservice.module';

import serviceCategoryRes from '../common/resources/servicecategory.resource';
import serviceGroupRes from '../common/resources/servicegroup.resource';

/**
 * Amount of times to fetch
 * @type {number}
 */
const TIME_AMOUNT = 3;

/**
 * Standalone component to display three (default) closest available times.
 * The component will be disabled and will display an error message if
 * location is not available.
 */
class NextTimesComponent {
  constructor(
    $q,
    $log,
    $window,
    usSpinnerService,
    GeolocationService,
    NextTimesResource,
    UrlService,
    PersonResource,
    CityResource,
    LocationResource,
    ServiceResource,
    InfoModal,
    gettextCatalog,
    ServiceCategoryResource,
    ServiceGroupResource,
    FlashMessageService
  ) {
    'ngInject';

    this.$q = $q;
    this.$log = $log;
    this.$window = $window;
    this.usSpinnerService = usSpinnerService;
    this.GeolocationService = GeolocationService;
    this.NextTimesResource = NextTimesResource;
    this.PersonResource = PersonResource;
    this.CityResource = CityResource;
    this.LocationResource = LocationResource;
    this.ServiceResource = ServiceResource;
    this.UrlService = UrlService;
    this.InfoModal = InfoModal;
    this.ServiceCategoryResource = ServiceCategoryResource;
    this.ServiceGroupResource = ServiceGroupResource;
    this.gettextCatalog = gettextCatalog;
    this.locationStorage = new LocationStorage();
    this.FlashMessageService = FlashMessageService;

    /**
     * Loading new times from the backend?
     * @type {Boolean}
     */
    this.loading = false;

    /**
     * Reservation slots retrieved from the backend for display.
     * @type {Array.<ReservationSlot>}
     */
    this.slots = [];

    /**
     * Set to true if getting user's location fails.
     * @type {Boolean}
     */
    this.locationFailure = false;

    /**
     * Location that is used for filtering, if given.
     * @type {?Location}
     */
    this.location = null;

    /**
     * City that is used for filtering, if given.
     * @type {?City}
     */
    this.city = null;

    /**
     * Person that is used for filtering, if given.
     * @type {?Person}
     */
    this.person = null;

    /**
     * User's coordinates from the geolocation API, if available.
     * @type {null}
     */
    this.geolocation = null;

    /**
     * Service that is used for filtering, if given.
     * @type {?Service}
     */
    this.service = null;

    /**
     * Previous parameters that were used to fetch next times. Can be used to
     * prevent fetching again with same params.
     * @type {?Object}
     */
    this.previousParams = null;

    /**
     * Amount of times to fetch from remote.
     * @type {?Number}
     */
    this.timeAmount = null;

    /**
     * Possible preset person.
     * @type {?Number}
     */
    this.personId = null;

    /**
     * Possible preset service
     * @type {?Number}
     */
    this.serviceId = null;

    /**
     * Possible list of ids for locations that are allowed as location selections.
     * @type {?Array.<Number>}
     */
    this.locationIds = null;

    /**
     * Possible list of ids for cities that are allowed as city selections.
     * @type {?Array.<Number>}
     */
    this.cityIds = null;

    /**
     * Possible list of ids for services that are allowed as service selections.
     * @type {?Array.<Number>}
     */
    this.serviceIds = null;

    /**
     * Has the component finished loading for the first time.
     * @type {boolean}
     */
    this.loaded = false;

    this.locating = false;

    this.serviceBookingUrl = null;
    this.showMoreUrl = null;

    /**
     * Possible prefilled voucher code
     * @type {?String}
     */
    this.voucher = null;

    this.useCities = null;

    this.timeSelectionTpl = timeSelectionTpl;
    this.locationInfoTpl = locationInfoTpl;
    this.timesContainerTpl = timesContainerTpl;
    this.nonReservableTpl = nonReservableTpl;
    this.noTimesTpl = noTimesTpl;
    this.offlineTpl = offlineTpl;
    this.spinnerTpl = spinnerTpl;

    this.personTitle  = gettextCatalog.getString('Asiantuntija');
    this.locationTitle = gettextCatalog.getString('Toimipiste');
  }

  getGeolocation() {
    const update = () => {
      this.city = null;
      this.cityId = null;
      this.location = null;
      this.locationId = null;
      this.locating = false;
      this.updateTimes();
    }

    if (this.geolocation == null && !this.locationFailure) {
      this.loading = true;
      this.locating = true;
      this.GeolocationService.getLocation()
        .then(location => {
          this.geolocation = location.coords;
          update();
        })
        .catch(() => {
          this.locationFailure = true;
          this.loading = false;
          this.locating = false;
          this.FlashMessageService.addMessage(
            this.gettextCatalog.getString(
              'Paikannusvirhe: olet kieltänyt paikannuksen tai selaimesi ei tue paikannusta.'
            ),
            'error'
          );
        })
    } else {
      update();
    }
  }

  newLocation(location) {
    this.$log.debug('Selected location', location);
    // Setting a location requires fetching full data so no updating when selection
    // remains the same.
    let oldLocationId = null;
    if (this.location != null) {
      oldLocationId = this.location.id;
    }

    if (location != null && location.obj != null && oldLocationId !== location.obj.id) {
      this.location = location.obj;
      this.updateTimes();
    }
  }

  newCity(city) {
    this.$log.debug('Selected city', city);
    // Setting a city requires fetching full data so no updating when selection
    // remains the same.
    let oldCityId = null;
    if (this.city != null) {
      oldCityId = this.city.id;
    }

    if (city != null && city.obj != null && oldCityId !== city.obj.id) {
      this.city = city.obj;
      this.updateTimes();
    }
  }

  newService(service) {
    this.$log.debug('Selected service', service);
    this.service = service == null ? null : service.obj;

    if (this.service == null || this.service.internet_reservable) {
      this.updateTimes();
    }
  }

  timeslotGetParams() {
    const params = {
      coordinates: this.geolocation,
      person: this.personId
    };

    if (this.location != null) {
      params.location = this.location.id
      params.coordinates = null;
    }
    else if (this.locationId != null) {
      params.location = this.locationId;
      params.coordinates = null;
    }

    if (this.city != null) {
      params.city = this.city.id;
      params.coordinates = null;
      params.location = null;
    }
    else if (this.cityId != null) {
      params.city = this.cityId;
      params.coordinates = null;
      params.location = null;
    }

    if (this.service != null) {
      params.service = this.service.id;
    }
    else if (this.serviceId != null) {
      params.service = this.serviceId;
    }

    return params;
  }

  $onInit() {
    this.timeAmount = this.timeAmount || TIME_AMOUNT;

    this.$log.debug("Init next times with amount", this.timeAmount, "person", this.personId, "voucher", this.voucher);

    if (this.personId != null) {
      this.PersonResource.getOne(this.personId).then(person => {
        this.person = person;
        this.locationIds = person.locations;
        this.serviceIds = person.services;
        this.locationId = person.locations[0];
        this.$log.debug(`Initial values from person: service ${this.serviceId}, location ${this.locationId}`);

        // Set loaded to true so the rest of the form will load.
        this.loaded = true;
      })
        .then(() => this.updateTimes());
    }
    else if (this.locationId != null) {
      this.LocationResource.getOne(this.locationId).then(location => {
        this.location = location;
        this.$log.debug(`Initial values from location: service ${this.serviceId}, location ${this.locationId}`);

        // Do NOT call update times as service selector will return with the correct value.
        // Just set loaded to true so the rest of the form will load.
        this.loaded = true;
      });
    }
    else if (this.cityId != null) {
      this.CityResource.getOne(this.cityId).then(city => {
        this.city = city;
        this.$log.debug(`Initial values from city: service ${this.serviceId}, city ${this.cityId}`);

        // Do NOT call update times as service selector will return with the correct value.
        // Just set loaded to true so the rest of the form will load.
        this.loaded = true;
      })
    }
    // Service version needs to fetch the service object as it is not handled by service selector
    else if (this.serviceId != null) {
      return this._getLocationsOrCities({getService: true});
    }
    else {
      // No given params, select default service (template) and default location
      return this._getLocationsOrCities({ getService: false });
    }
  }

  _getLocationsOrCities({getService}) {
    const locationOrCityResource = this.useCities ? this.CityResource : this.LocationResource;
    const servicePromise = getService ? this.ServiceResource.getOne(this.serviceId) : Promise.resolve(null);

    return this.$q.all([locationOrCityResource.getAll(), servicePromise])
      .then(([locationsOrCities, service]) => {
        service ? this.service = service : null;
        const locationOrCity = locationsOrCities.list.find(locOrCity => locOrCity.is_default === true);
        const locationOrCityId = locationOrCity == null ? null : locationOrCity.id;
        this.useCities ? (this.city = locationOrCity, this.cityId = locationOrCityId) : (this.location = locationOrCity, this.locationId = locationOrCityId);
      })
      .then(() => this.updateTimes());
  }

  updateTimes() {
    const params = this.timeslotGetParams();

    // Don't bother fetching if service and person are not defined or if location, city and coordinates are not defined
    if (params.service == null && params.person == null || params.location == null && params.city == null && params.coordinates == null) {
      return;
    }

    // Same params so reload not needed.
    if (JSON.stringify(params) === JSON.stringify(this.previousParams)) {
      return;
    }

    const p = this._reservationParams();
    this.UrlService.reservationURL(p)
    .then(url => this.showMoreUrl = url);
    this.UrlService.reservationURL({serviceId: p.serviceId})
    .then(url => this.serviceBookingUrl = url);

    // Clear slots when loading
    this.slots = [];
    this.loading = true;
    this.previousParams = params;

    // Get the next times and full information about the active location if one is selected, in parallel
    const next_times_promises = [
      this.NextTimesResource.filterTimes(params,
        this.timeAmount
      )
    ];

    if (this.location != null) {
      next_times_promises.push(this.LocationResource.getOne(this.location.id));
    }
    else if (this.locationId != null) {
      next_times_promises.push(this.LocationResource.getOne(this.locationId));
    }

    if (this.city != null) {
      next_times_promises.push(this.CityResource.getOne(this.city.id));
    }
    else if (this.cityId != null) {
      next_times_promises.push(this.CityResource.getOne(this.cityId));
    }

    this.$q.all(next_times_promises).then(([data, location, city]) => {
      this.location = location;
      this.city = city;

      if (location && location.address && location.address.postal_area) {
        this.locationStorage.setLocationPageVisitCity(location.address.postal_area);
      }

      this.slots = data.copy();
      // Map over slots creating promises which are resolved when URLs are fetched
      this.slotsPromises = this.slots.list.map(originalSlot => {
        const slot = originalSlot.copy();
        // Endpoint location is lacking a few fields
        // Only update location of slot if cities are used to fetch the slots
        location && !this.useCities ? slot.location = location : null;
        const slotParams = this._reservationParams();
        slotParams.timeslotId = slot.id;
        return this.UrlService.reservationURL(slotParams).then(url => {
          slot.url = url;
          return slot.makeImmutable();
        });
      });
      return this.$q.all(this.slotsPromises).then(slots => this.slots = slots);
    })
    .then(() => {
      // With geolocation we don't know the exact city or location so fallback to the location of the first reservation slot
      if (!this.city && !this.location && this.slots && this.slots.length) {
        p.locationId = this.slots[0].location.id;
        return this.UrlService.reservationURL(p)
          .then(url => this.showMoreUrl = url);
      }
    })
    .finally(() => {
      this.loading = false;
      this.loaded = true;
    });
  }

  _reservationParams() {
    let params = {
      personId: this.personId,
      serviceId: this.serviceId,
      locationId: this.locationId,
      cityId: this.cityId
    };

    if (this.service != null) {
      params.serviceId = this.service.id;
    }

    if (this.location != null) {
      params.locationId = this.location.id;
      params.cityId = null;
    }

    if (this.voucher != null) {
      params.voucher = this.voucher;
    }

    if (this.city != null) {
      params.cityId = this.city.id;
      params.locationId = null;
    }

    return params;
  }

  /**
   * Check if the given service is available as internet reservable in this location or for this person.
   * @private
   */
  _internetAvailable() {
    if (this.person != null && this.person.services != null) {
      return this.person.services.includes(this.service.id);
    }
    else if (this.location != null && this.location.services != null) {
      return this.location.services.includes(this.service.id);
    }
    else if (this.city != null && this.city.services != null) {
      return this.city.services.includes(this.service.id);
    }

    return true;
  }
}

const REQUIRED_IMPORTS = [
  angularSpinner,
  cityResource,
  locationResource,
  serviceResource,
  geolocationService,
  nextTimesResource,
  personResource,
  urlServiceMod,
  navButtonComponentMod,
  selectTimeButtonMod,
  normalButtonComponentMod,
  commonUrlFiltersMod,
  infoModalMod,
  serviceGroupRes,
  serviceCategoryRes,
  flashMessageMod
];

const config = {
  templateUrl: nextTimesTpl,
  controller: NextTimesComponent,
  bindings: {
    personId: '<?',
    locationId: '<?',
    serviceId: '<?',
    timeAmount: '<?',
    voucher: '<?',
    useCities: '<?'
  }
};

const personConfig = {
  templateUrl: nextTimesPersonTpl,
  controller: NextTimesComponent,
  bindings: {
    personId: '<?',
    timeAmount: '<?',
    voucher: '<?',
  }
};

const locationConfig = {
  templateUrl: nextTimesLocationTpl,
  controller: NextTimesComponent,
  bindings: {
    locationId: '<?',
    timeAmount: '<?',
    voucher: '<?',
  }
};

const serviceConfig = {
  templateUrl: nextTimesServiceTpl,
  controller: NextTimesComponent,
  bindings: {
    serviceId: '<?',
    timeAmount: '<?',
    voucher: '<?',
  }
};

export {
  REQUIRED_IMPORTS,
  personConfig,
  locationConfig,
  serviceConfig
};
export default config;



// WEBPACK FOOTER //
// ./src/app/next-times/next-times.component.js